import React, { useEffect, useState } from "react";
import { Form, Card } from "react-bootstrap";
import { FormHelper } from "utils";
import DropZone from "components/DropZone/Dropzone";
import EditHeader from "components/PantallasEdit/Header/EditHeader";
import EditContainer from "components/PantallasEdit/EditContainer/EditContainer";
import EditSection from "components/PantallasEdit/EditSection/EditSection";
import SectionRow from "components/PantallasEdit/SectionRow/SectionRow";
import InputContainer from "components/PantallasEdit/InputContainer/InputContainer";
import { CredencialesCertificacionManager } from "managers";
import useExceptionHandler from "hooks/useExceptionHandler";
import useMessage from "hooks/useMessage";

export default function CredencialesCertificacion({
  showLoading,
  hideLoading,
  isActive = true,
}) {
  const [credenciales, setCredenciales] = useState({});
  const { handleException } = useExceptionHandler();
  const { Message, Types, cerrarAlertas } = useMessage();

  useEffect(() => {
    return () => {
      cerrarAlertas();
      hideLoading?.();
    };
  }, []);

  const onFileChange = (propFile, propName) => {
    setCredenciales({ ...credenciales, [propName]: propFile });
  };

  const enviarCredenciales = () => {
    showLoading?.();
    CredencialesCertificacionManager.enviar(credenciales)
      .then(() => {
        Message({
          message: "Credenciales enviadas correctamente.",
          autoDismiss: 1.5,
        });
        setCredenciales({});
      })
      .catch((e) => handleException(e))
      .finally(() => hideLoading?.());
  };

  return isActive ? (
    <Form
      action=""
      className="form-horizontal p-3"
      id="CredencialesCertificacion"
      method=""
      autoComplete="off"
    >
      <Card className="p-0 m-0">
        <EditHeader
          titulo="Enviar Credenciales Certificación Electrónica"
          grabar={false}
          enviarCredenciales={enviarCredenciales}
          showLoading={showLoading}
          hideLoading={hideLoading}
          isInSimpleBar={true}
        />
        <EditContainer>
          <EditSection title="Credenciales Portal de Certificación DGII">
            <SectionRow>
              <InputContainer label="RNC/Cédula" labelSize={3} required={true}>
                <Form.Control
                  name="RNCCedula"
                  type="text"
                  placeholder="RNC/Cédula"
                  onChange={(e) => FormHelper.handleChange(e, setCredenciales)}
                  value={credenciales.RNCCedula || ""}
                />
              </InputContainer>
            </SectionRow>
            <SectionRow>
              <InputContainer label="Contraseña" labelSize={3} required={true}>
                <Form.Control
                  name="Contrasena"
                  type="password"
                  placeholder="Contraseña"
                  onChange={(e) => FormHelper.handleChange(e, setCredenciales)}
                  value={credenciales.Contrasena || ""}
                />
              </InputContainer>
            </SectionRow>
          </EditSection>

          <EditSection title="Credenciales Firma Digital (Certificado)" mt={"mt-5"}>
            <SectionRow>
              <InputContainer label="Key Certificado" labelSize={3} required={true}>
                <Form.Control
                  name="KeyCertificado"
                  type="password"
                  placeholder="Key Certificado"
                  onChange={(e) => FormHelper.handleChange(e, setCredenciales)}
                  value={credenciales.KeyCertificado || ""}
                />
              </InputContainer>
            </SectionRow>
            <SectionRow>
              <InputContainer label="Certificado (.p12)" labelSize={3} required={true}>
                <div style={{ width: "100%" }}>
                  <DropZone
                    label="Seleccione un archivo .p12"
                    updateFilesCb={(f) => onFileChange(f, "Certificado")}
                    multiple={false}
                    type="p12"
                  />
                </div>
              </InputContainer>
            </SectionRow>
          </EditSection>
        </EditContainer>
      </Card>
    </Form>
  ) : (
    <></>
  );
}
